<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="redColor">
        <span class="headline text-white">{{ $t("parts.table.actions") }}</span>
      </v-card-title>
      <v-card-text class="pa-1">
        <v-container>
          <v-row align-center justify-center wrap>
            <!----------------------------------------ALERT---------------------------------------->
            <v-col cols="12" xs="12" md="12" lg="12">
              <v-alert
                :model-value="alert.value"
                type="warning"
                variant="tonal"
                border="bottom"
              >
                <v-row align="center" class="py-1">
                  <v-col cols="12" sm="8">
                    {{ alert.message }}
                  </v-col>
                  <v-col cols="12" sm="4">
                    <!-- Mobile: stacked full-width buttons -->
                    <div class="d-flex d-sm-none flex-column ga-2 mt-2">
                      <v-btn
                        variant="outlined"
                        color="success"
                        block
                        @click="((confirm = true), (alert.value = false))"
                      >
                        {{ $t("parts.lost_parts.actions.alert.yes") }}
                      </v-btn>
                      <v-btn
                        variant="outlined"
                        color="error"
                        block
                        @click="((confirm = false), (alert.value = false))"
                      >
                        {{ $t("parts.lost_parts.actions.alert.no") }}
                      </v-btn>
                    </div>
                    <!-- Desktop: inline buttons -->
                    <v-row class="d-none d-sm-flex mt-2">
                      <v-btn
                        variant="outlined"
                        size="small"
                        color="success"
                        class="mx-1"
                        @click="((confirm = true), (alert.value = false))"
                      >
                        {{ $t("parts.lost_parts.actions.alert.yes") }}
                      </v-btn>
                      <v-btn
                        variant="outlined"
                        size="small"
                        color="error"
                        class="mx-1"
                        @click="((confirm = false), (alert.value = false))"
                      >
                        {{ $t("parts.lost_parts.actions.alert.no") }}
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
            <!---------------------------------------BUTTONS--------------------------------------->
            <v-col cols="6" lg="6" md="6" xs="12" sm="6">
              <v-switch
                v-model="switchI"
                :label="$t('parts.lost_parts.actions.inventory')"
                color="success"
              />
            </v-col>
            <v-col cols="6" lg="6" md="6" xs="12" sm="6">
              <v-switch
                v-model="switchD"
                :label="$t('parts.lost_parts.actions.damaged')"
                color="orange"
              />
            </v-col>
            <!------------------------------------------------------------------------------------->
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("parts.lost_parts.actions.close") }}
        </v-btn>
        <v-btn
          v-if="switchI"
          :loading="loading"
          :disabled="!confirm"
          color="success"
          variant="outlined"
          @click="inventory"
        >
          {{ $t("parts.lost_parts.actions.inventory") }}
        </v-btn>
        <v-btn
          v-if="switchD"
          :loading="loading"
          :disabled="!confirm"
          color="orange"
          variant="outlined"
          @click="damaged"
        >
          {{ $t("parts.lost_parts.actions.damaged") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    loading: false,
    dialog: false,
    switchI: false,
    switchD: false,
    alert: {
      value: false,
      message: "",
    },
    confirm: false,
    part: {},
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.part = {};
        this.$emit("close");
      }
    },
    switchI(value) {
      if (value) {
        this.switchD = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.lost_parts.actions.alert.inventory_message",
        );
      } else if (!this.switchD) {
        this.confirm = false;
        this.alert.value = false;
        this.alert.message = "";
      }
    },
    switchD(value) {
      if (value) {
        this.switchI = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.lost_parts.actions.alert.damaged_message",
        );
      } else if (!this.switchI) {
        this.confirm = false;
        this.alert.value = false;
        this.alert.message = "";
      }
    },
  },
  methods: {
    open(part) {
      this.part = part;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.part = {};
      this.$emit("close");
    },
    inventory() {
      this.loading = true;
      putRequest(
        `/part/inventory/${this.part._id}`,
        `user_id=${this.$store.getters.userId}&institution_id=${
          this.$store.getters.institutionId
        }&source=lost`,
      )
        .then(() => {
          this.loading = false;
          this.close();
        })
        .catch(() => {
          this.loading = false;
          this.close();
        });
    },
    damaged() {
      this.loading = true;
      putRequest(
        `/part/damaged/${this.part._id}`,
        `user_id=${this.$store.getters.userId}&institution_id=${
          this.$store.getters.institutionId
        }&source=lost`,
      )
        .then(() => {
          this.loading = false;
          this.close();
        })
        .catch(() => {
          this.loading = false;
          this.close();
        });
    },
  },
};
</script>
